import { Box, styled } from '@mui/material';
import { Button } from '../../../../components/atoms/Button';

export const StyledBox = styled(Box)`
  width: 100%;
`;

export const StyledButton = styled(Button)`
  line-height: 100px;
`;